export default [
  {
    path: "/doc/atmrequirement",
    name: "atmrequirement",
    component: () => import("@/views/document/atmrequirement/index.vue"),
    meta: {
      pageTitle: "AtmRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmrequirement/edit/id=:id",
    name: "EditAtmRequirement",
    component: () => import("@/views/document/atmrequirement/edit.vue"),
    meta: {
      pageTitle: "AtmRequirement",
      navActiveLink: "atmrequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmrequirement/view/id=:id",
    name: "ViewAtmRequirement",
    component: () => import("@/views/document/atmrequirement/view.vue"),
    meta: {
      pageTitle: "AtmRequirement",
      navActiveLink: "atmrequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmmovement",
    name: "atmmovement",
    component: () => import("@/views/document/atmmovement/index.vue"),
    meta: {
      pageTitle: "AtmMovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmmovement/edit/id=:id",
    name: "EditAtmMovement",
    component: () => import("@/views/document/atmmovement/edit.vue"),
    meta: {
      pageTitle: "AtmMovement",
      navActiveLink: "atmmovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmmovement/view/id=:id",
    name: "ViewAtmMovement",
    component: () => import("@/views/document/atmmovement/view.vue"),
    meta: {
      pageTitle: "AtmMovement",
      navActiveLink: "atmmovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/cassettemovement",
    name: "cassettemovement",
    component: () => import("@/views/document/cassettemovement/index.vue"),
    meta: {
      pageTitle: "CassetteMovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CassetteMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/cassettemovement/edit/id=:id",
    name: "EditCassetteMovement",
    component: () => import("@/views/document/cassettemovement/edit.vue"),
    meta: {
      pageTitle: "CassetteMovement",
      navActiveLink: "cassettemovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CassetteMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/cassettemovement/view/id=:id",
    name: "ViewCassetteMovement",
    component: () => import("@/views/document/cassettemovement/view.vue"),
    meta: {
      pageTitle: "CassetteMovement",
      navActiveLink: "cassettemovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CassetteMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmdevicesettings",
    name: "atmdevicesettings",
    component: () => import("@/views/document/atmdevicesettings/index.vue"),
    meta: {
      pageTitle: "AtmDeviceSettings",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmDeviceSettings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmdevicesettings/edit/id=:id",
    name: "EditAtmDeviceSettings",
    component: () => import("@/views/document/atmdevicesettings/edit.vue"),
    meta: {
      pageTitle: "AtmDeviceSettings",
      navActiveLink: "atmdevicesettings",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmDeviceSettings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmdevicesettings/view/id=:id",
    name: "ViewAtmDeviceSettings",
    component: () => import("@/views/document/atmdevicesettings/view.vue"),
    meta: {
      pageTitle: "AtmDeviceSettings",
      navActiveLink: "atmdevicesettings",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmDeviceSettings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/cassettesettings",
    name: "cassettesettings",
    component: () => import("@/views/document/cassettesettings/index.vue"),
    meta: {
      pageTitle: "CassetteSettings",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CassetteSettings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/cassettesettings/edit/id=:id",
    name: "EditCassetteSettings",
    component: () => import("@/views/document/cassettesettings/edit.vue"),
    meta: {
      pageTitle: "CassetteSettings",
      navActiveLink: "cassettesettings",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CassetteSettings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/cassettesettings/view/id=:id",
    name: "ViewCassetteSettings",
    component: () => import("@/views/document/cassettesettings/view.vue"),
    meta: {
      pageTitle: "CassetteSettings",
      navActiveLink: "cassettesettings",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CassetteSettings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/sealermovement",
    name: "sealermovement",
    component: () => import("@/views/document/sealermovement/index.vue"),
    meta: {
      pageTitle: "SealerMovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SealerMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/sealermovement/edit/id=:id",
    name: "EditSealerMovement",
    component: () => import("@/views/document/sealermovement/edit.vue"),
    meta: {
      pageTitle: "SealerMovement",
      navActiveLink: "sealermovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SealerMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/sealermovement/view/id=:id",
    name: "ViewSealerMovement",
    component: () => import("@/views/document/sealermovement/view.vue"),
    meta: {
      pageTitle: "SealerMovement",
      navActiveLink: "sealermovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SealerMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/keychainmovement",
    name: "keychainmovement",
    component: () => import("@/views/document/keychainmovement/index.vue"),
    meta: {
      pageTitle: "KeychainMovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "KeychainMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/keychainmovement/edit/id=:id",
    name: "EditKeychainMovement",
    component: () => import("@/views/document/keychainmovement/edit.vue"),
    meta: {
      pageTitle: "KeychainMovement",
      navActiveLink: "keychainmovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "KeychainMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/keychainmovement/view/id=:id",
    name: "ViewKeychainMovement",
    component: () => import("@/views/document/keychainmovement/view.vue"),
    meta: {
      pageTitle: "KeychainMovement",
      navActiveLink: "keychainmovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "KeychainMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/setofkeymovement",
    name: "setofkeymovement",
    component: () => import("@/views/document/setofkeymovement/index.vue"),
    meta: {
      pageTitle: "SetOfKeyMovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SetOfKeyMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/setofkeymovement/edit/id=:id",
    name: "EditSetOfKeyMovement",
    component: () => import("@/views/document/setofkeymovement/edit.vue"),
    meta: {
      pageTitle: "SetOfKeyMovement",
      navActiveLink: "setofkeymovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SetOfKeyMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/setofkeymovement/view/id=:id",
    name: "ViewSetOfKeyMovement",
    component: () => import("@/views/document/setofkeymovement/view.vue"),
    meta: {
      pageTitle: "SetOfKeyMovement",
      navActiveLink: "setofkeymovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SetOfKeyMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bagbscmovement",
    name: "bagbscmovement",
    component: () => import("@/views/document/bagbscmovement/index.vue"),
    meta: {
      pageTitle: "BagBscMovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BagBscMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bagbscmovement/edit/id=:id",
    name: "EditBagBscMovement",
    component: () => import("@/views/document/bagbscmovement/edit.vue"),
    meta: {
      pageTitle: "BagBscMovement",
      navActiveLink: "bagbscmovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BagBscMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bagbscmovement/view/id=:id",
    name: "ViewBagBscMovement",
    component: () => import("@/views/document/bagbscmovement/view.vue"),
    meta: {
      pageTitle: "BagBscMovement",
      navActiveLink: "bagbscmovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BagBscMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmdeviceattachment",
    name: "atmdeviceattachment",
    component: () => import("@/views/document/atmdeviceattachment/index.vue"),
    meta: {
      pageTitle: "AtmDeviceAttachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmDeviceAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmdeviceattachment/edit/id=:id",
    name: "EditAtmDeviceAttachment",
    component: () => import("@/views/document/atmdeviceattachment/edit.vue"),
    meta: {
      pageTitle: "AtmDeviceAttachment",
      navActiveLink: "atmdeviceattachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmDeviceAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmdeviceattachment/view/id=:id",
    name: "ViewAtmDeviceAttachment",
    component: () => import("@/views/document/atmdeviceattachment/view.vue"),
    meta: {
      pageTitle: "AtmDeviceAttachment",
      navActiveLink: "atmdeviceattachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmDeviceAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/refillatm",
    name: "refillatm",
    component: () => import("@/views/document/refillatm/index.vue"),
    meta: {
      pageTitle: "RefillAtm",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "RefillAtm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/refillatm/view/id=:id",
    name: "ViewRefillAtm",
    component: () => import("@/views/document/refillatm/view.vue"),
    meta: {
      pageTitle: "RefillAtm",
      navActiveLink: "refillatm",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "RefillAtm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/refillatm-userchange",
    name: "refillatm-userchange",
    component: () => import("@/views/document/refillatm/userchange.vue"),
    meta: {
      pageTitle: "RefillAtmUserChange",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "RefillAtmUserChange",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bagbscattachment",
    name: "bagbscattachment",
    component: () => import("@/views/document/bagbscattachment/index.vue"),
    meta: {
      pageTitle: "BagBscAttachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BagBscAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bagbscattachment/edit/id=:id",
    name: "EditBagBscAttachment",
    component: () => import("@/views/document/bagbscattachment/edit.vue"),
    meta: {
      pageTitle: "BagBscAttachment",
      navActiveLink: "bagbscattachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BagBscAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bagbscattachment/view/id=:id",
    name: "ViewBagBscAttachment",
    component: () => import("@/views/document/bagbscattachment/view.vue"),
    meta: {
      pageTitle: "BagBscAttachment",
      navActiveLink: "bagbscattachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BagBscAttachment",
          active: true,
        },
      ],
    },
  },

  {
    path: "/doc/sealerattachment",
    name: "sealerattachment",
    component: () => import("@/views/document/sealerattachment/index.vue"),
    meta: {
      pageTitle: "SealerAttachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SealerAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/sealerattachment/edit/id=:id",
    name: "EditSealerAttachment",
    component: () => import("@/views/document/sealerattachment/edit.vue"),
    meta: {
      pageTitle: "SealerAttachment",
      navActiveLink: "sealerattachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SealerAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/sealerattachment/view/id=:id",
    name: "ViewSealerAttachmentt",
    component: () => import("@/views/document/sealerattachment/view.vue"),
    meta: {
      pageTitle: "SealerAttachment",
      navActiveLink: "sealerattachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SealerAttachment",
          active: true,
        },
      ],
    },
  },

  {
    path: "/doc/keychainattachment",
    name: "keychainattachment",
    component: () => import("@/views/document/keychainattachment/index.vue"),
    meta: {
      pageTitle: "KeyChainAttachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "KeyChainAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/keychainattachment/edit/id=:id",
    name: "EditKeyChainAttachment",
    component: () => import("@/views/document/keychainattachment/edit.vue"),
    meta: {
      pageTitle: "KeyChainAttachment",
      navActiveLink: "keychainattachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "KeyChainAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/keychainattachment/view/id=:id",
    name: "ViewKeyChainAttachment",
    component: () => import("@/views/document/keychainattachment/view.vue"),
    meta: {
      pageTitle: "KeyChainAttachment",
      navActiveLink: "keychainattachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "KeyChainAttachment",
          active: true,
        },
      ],
    },
  },

  {
    path: "/doc/setofkeyattachment",
    name: "setofkeyattachment",
    component: () => import("@/views/document/setofkeyattachment/index.vue"),
    meta: {
      pageTitle: "SetOfKeyAttachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SetOfKeyAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/setofkeyattachment/edit/id=:id",
    name: "EditSetOfKeyAttachment",
    component: () => import("@/views/document/setofkeyattachment/edit.vue"),
    meta: {
      pageTitle: "SetOfKeyAttachment",
      navActiveLink: "setofkeyattachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SetOfKeyAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/setofkeyattachment/view/id=:id",
    name: "ViewSetOfKeyAttachment",
    component: () => import("@/views/document/setofkeyattachment/view.vue"),
    meta: {
      pageTitle: "SetOfKeyAttachment",
      navActiveLink: "setofkeyattachment",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SetOfKeyAttachment",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/emptyingatm",
    name: "emptyingatm",
    component: () => import("@/views/document/emptyingatm/index.vue"),
    meta: {
      pageTitle: "EmptyingAtm",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EmptyingAtm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/emptyingatm/view/id=:id",
    name: "ViewEmptyingAtm",
    component: () => import("@/views/document/emptyingatm/view.vue"),
    meta: {
      pageTitle: "EmptyingAtm",
      navActiveLink: "emptyingatm",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "EmptyingAtm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nonstandartsituation",
    name: "nonstandartsituation",
    component: () => import("@/views/document/nonstandartsituation/index.vue"),
    meta: {
      pageTitle: "NonStandartSituation",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NonStandartSituation",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nonstandartsituation/view/id=:id",
    name: "ViewNonStandartSituation",
    component: () => import("@/views/document/nonstandartsituation/view.vue"),
    meta: {
      pageTitle: "NonStandartSituation",
      navActiveLink: "nonstandartsituation",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NonStandartSituation",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/receivingvaluables",
    name: "receivingvaluables",
    component: () => import("@/views/document/receivingvaluables/index.vue"),
    meta: {
      pageTitle: "ReceivingValuables",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ReceivingValuables",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/receivingvaluables/view/id=:id",
    name: "ViewReceivingValuables",
    component: () => import("@/views/document/receivingvaluables/view.vue"),
    meta: {
      pageTitle: "ReceivingValuables",
      navActiveLink: "receivingvaluables",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "ReceivingValuables",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/machinereadablecodesetting",
    name: "machinereadablecodesetting",
    component: () =>
      import("@/views/document/machinereadablecodesetting/index.vue"),
    meta: {
      pageTitle: "MachineReadableCodeSetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "MachineReadableCodeSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/machinereadablecodesetting/edit/id=:id",
    name: "EditMachineReadableCodeSetting",
    component: () =>
      import("@/views/document/machinereadablecodesetting/edit.vue"),
    meta: {
      pageTitle: "MachineReadableCodeSetting",
      navActiveLink: "machinereadablecodesetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "MachineReadableCodeSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/machinereadablecodesetting/view/id=:id",
    name: "ViewMachineReadableCodeSetting",
    component: () =>
      import("@/views/document/machinereadablecodesetting/view.vue"),
    meta: {
      pageTitle: "MachineReadableCodeSetting",
      navActiveLink: "machinereadablecodesetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "MachineReadableCodeSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/specialgroup",
    name: "specialgroup",
    component: () => import("@/views/document/specialgroup/index.vue"),
    meta: {
      pageTitle: "SpecialGroup",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SpecialGroup",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/specialgroup/edit/id=:id",
    name: "EditSpecialGroup",
    component: () => import("@/views/document/specialgroup/edit.vue"),
    meta: {
      pageTitle: "SpecialGroup",
      navActiveLink: "specialgroup",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SpecialGroup",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/specialgroup/view/id=:id",
    name: "ViewSpecialGroup",
    component: () => import("@/views/document/specialgroup/view.vue"),
    meta: {
      pageTitle: "SpecialGroup",
      navActiveLink: "specialgroup",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SpecialGroup",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/specialgroupsettings",
    name: "specialgroupsettings",
    component: () => import("@/views/document/specialgroupsettings/index.vue"),
    meta: {
      pageTitle: "SpecialGroupSettings",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SpecialGroupSettings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/specialgroupsettings/edit/id=:id",
    name: "EditSpecialGroupSettings",
    component: () => import("@/views/document/specialgroupsettings/edit.vue"),
    meta: {
      pageTitle: "SpecialGroupSettings",
      navActiveLink: "specialgroupsettings",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SpecialGroupSettings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/specialgroupsettings/view/id=:id",
    name: "ViewSpecialGroupSettings",
    component: () => import("@/views/document/specialgroupsettings/view.vue"),
    meta: {
      pageTitle: "SpecialGroupSettings",
      navActiveLink: "specialgroupsettings",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SpecialGroupSettings",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/usersession",
    name: "usersession",
    component: () => import("@/views/document/usersession/index.vue"),
    meta: {
      pageTitle: "UserSession",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "UserSession",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/mobileappversion",
    name: "mobileappversion",
    component: () => import("@/views/document/mobileappversion/index.vue"),
    meta: {
      pageTitle: "MobileAppVersion",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "MobileAppVersion",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmdashboard",
    name: "atmdashboard",
    component: () => import("@/views/document/atmdashboard/index.vue"),
    meta: {
      pageTitle: "AtmDashboard",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmDashboard",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscrequirement",
    name: "bscrequirement",
    component: () => import("@/views/document/bscrequirement/index.vue"),
    meta: {
      pageTitle: "BscRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscrequirement/edit/id=:id",
    name: "EditBscRequirement",
    component: () => import("@/views/document/bscrequirement/edit.vue"),
    meta: {
      pageTitle: "BscRequirement",
      navActiveLink: "bscrequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscrequirement/view/id=:id",
    name: "ViewBscRequirement",
    component: () => import("@/views/document/bscrequirement/view.vue"),
    meta: {
      pageTitle: "BscRequirement",
      navActiveLink: "bscrequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscmoneymovement",
    name: "bscmoneymovement",
    component: () => import("@/views/document/bscmoneymovement/index.vue"),
    meta: {
      pageTitle: "BscMoneyMovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscMoneyMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscmoneymovement/edit/id=:id",
    name: "EditBscMoneyMovement",
    component: () => import("@/views/document/bscmoneymovement/edit.vue"),
    meta: {
      pageTitle: "BscMoneyMovement",
      navActiveLink: "bscmoneymovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscMoneyMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscmoneymovement/view/id=:id",
    name: "ViewBscMoneyMovement",
    component: () => import("@/views/document/bscmoneymovement/view.vue"),
    meta: {
      pageTitle: "BscMoneyMovement",
      navActiveLink: "bscmoneymovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscMoneyMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscsetting",
    name: "bscsetting",
    component: () => import("@/views/document/bscsetting/index.vue"),
    meta: {
      pageTitle: "BscSetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscsetting/edit/id=:id",
    name: "EditBscSetting",
    component: () => import("@/views/document/bscsetting/edit.vue"),
    meta: {
      pageTitle: "BscSetting",
      navActiveLink: "bscsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscsetting/view/id=:id",
    name: "ViewBscSetting",
    component: () => import("@/views/document/bscsetting/view.vue"),
    meta: {
      pageTitle: "BscSetting",
      navActiveLink: "bscsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nmdsetting",
    name: "nmdsetting",
    component: () => import("@/views/document/nmdsetting/index.vue"),
    meta: {
      pageTitle: "NmdSetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NmdSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nmdsetting/edit/id=:id",
    name: "EditNmdSetting",
    component: () => import("@/views/document/nmdsetting/edit.vue"),
    meta: {
      pageTitle: "NmdSetting",
      navActiveLink: "nmdsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NmdSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nmdsetting/view/id=:id",
    name: "ViewNmdSetting",
    component: () => import("@/views/document/nmdsetting/view.vue"),
    meta: {
      pageTitle: "NmdSetting",
      navActiveLink: "nmdsetting",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NmdSetting",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/correctiondocument",
    name: "correctiondocument",
    component: () => import("@/views/document/correctiondocument/index.vue"),
    meta: {
      pageTitle: "CorrectionDocument",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CorrectionDocument",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/correctiondocument/edit/id=:id",
    name: "EditCorrectionDocument",
    component: () => import("@/views/document/correctiondocument/edit.vue"),
    meta: {
      pageTitle: "CorrectionDocument",
      navActiveLink: "correctiondocument",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CorrectionDocument",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/correctiondocument/view/id=:id",
    name: "ViewCorrectionDocument",
    component: () => import("@/views/document/correctiondocument/view.vue"),
    meta: {
      pageTitle: "CorrectionDocument",
      navActiveLink: "correctiondocument",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CorrectionDocument",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscnonstandartsituation",
    name: "bscnonstandartsituation",
    component: () =>
      import("@/views/document/bscnonstandartsituation/index.vue"),
    meta: {
      pageTitle: "BscNonstandartSituation",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscNonstandartSituation",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscnonstandartsituation/edit/id=:id",
    name: "EditBscNonstandartSituation",
    component: () =>
      import("@/views/document/bscnonstandartsituation/edit.vue"),
    meta: {
      pageTitle: "BscNonstandartSituation",
      navActiveLink: "bscnonstandartsituation",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscNonstandartSituation",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscnonstandartsituation/view/id=:id",
    name: "ViewBscNonstandartSituation",
    component: () =>
      import("@/views/document/bscnonstandartsituation/view.vue"),
    meta: {
      pageTitle: "BscNonstandartSituation",
      navActiveLink: "bscnonstandartsituation",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscNonstandartSituation",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscsettlementaccountconfig",
    name: "bscsettlementaccountconfig",
    component: () =>
      import("@/views/info/bscsettlementaccountconfig/index.vue"),
    meta: {
      pageTitle: "BscSettlementAccountConfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscsettlementaccountconfig/edit/id=:id",
    name: "EditBscSettlementAccountConfig",
    component: () => import("@/views/info/bscsettlementaccountconfig/edit.vue"),
    meta: {
      pageTitle: "BscSettlementAccountConfig",
      navActiveLink: "bscsettlementaccountconfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscsettlementaccountconfig/view/id=:id",
    name: "ViewBscSettlementAccountConfig",
    component: () => import("@/views/info/bscsettlementaccountconfig/view.vue"),
    meta: {
      pageTitle: "BscSettlementAccountConfig",
      navActiveLink: "bscsettlementaccountconfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nomadiccashrequirement",
    name: "nomadiccashrequirement",
    component: () =>
      import("@/views/document/nomadiccashrequirement/index.vue"),
    meta: {
      pageTitle: "NomadicCashRequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NomadicCashRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nomadiccashrequirement/edit/id=:id",
    name: "EditNomadicCashRequirement",
    component: () => import("@/views/document/nomadiccashrequirement/edit.vue"),
    meta: {
      pageTitle: "NomadicCashRequirement",
      navActiveLink: "nomadiccashrequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NomadicCashRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nomadiccashrequirement/view/id=:id",
    name: "ViewNomadicCashRequirement",
    component: () => import("@/views/document/nomadiccashrequirement/view.vue"),
    meta: {
      pageTitle: "NomadicCashRequirement",
      navActiveLink: "nomadiccashrequirement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NomadicCashRequirement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nomadiccashmoneymovement",
    name: "nomadiccashmoneymovement",
    component: () =>
      import("@/views/document/nomadiccashmoneymovement/index.vue"),
    meta: {
      pageTitle: "NomadicCashMoneyMovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NomadicCashMoneyMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nomadiccashmoneymovement/edit/id=:id",
    name: "EditNomadicCashMoneyMovement",
    component: () =>
      import("@/views/document/nomadiccashmoneymovement/edit.vue"),
    meta: {
      pageTitle: "NomadicCashMoneyMovement",
      navActiveLink: "nomadiccashmoneymovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NomadicCashMoneyMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nomadiccashmoneymovement/view/id=:id",
    name: "ViewNomadicCashMoneyMovement",
    component: () =>
      import("@/views/document/nomadiccashmoneymovement/view.vue"),
    meta: {
      pageTitle: "NomadicCashMoneyMovement",
      navActiveLink: "nomadiccashmoneymovement",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NomadicCashMoneyMovement",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/techinspection",
    name: "techinspection",
    component: () => import("@/views/document/techinspection/index.vue"),
    meta: {
      pageTitle: "TechInspection",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "TechInspection",
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/doc/techinspection/edit/id=:id',
  //   name: 'EditTechInspection',
  //   component: () => import('@/views/document/techinspection/edit.vue'),
  //   meta: {
  //     pageTitle: 'TechInspection',
  //     navActiveLink : 'techinspection',
  //     breadcrumb: [
  //       {
  //         text: 'Document',
  //       },
  //       {
  //         text: 'TechInspection',
  //         active: true,
  //       },
  //     ]
  //   },
  // },
  {
    path: "/doc/techinspection/view/id=:id",
    name: "ViewTechInspection",
    component: () => import("@/views/document/techinspection/view.vue"),
    meta: {
      pageTitle: "TechInspection",
      navActiveLink: "techinspection",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "TechInspection",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmtechalgorithm",
    name: "atmtechalgorithm",
    component: () => import("@/views/document/atmtechalgorithm/index.vue"),
    meta: {
      pageTitle: "AtmTechAlgorithm",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmTechAlgorithm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmtechalgorithm/edit/id=:id",
    name: "EditAtmTechAlgorithm",
    component: () => import("@/views/document/atmtechalgorithm/edit.vue"),
    meta: {
      pageTitle: "AtmTechAlgorithm",
      navActiveLink: "atmtechalgorithm",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmTechAlgorithm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/atmtechalgorithm/view/id=:id",
    name: "ViewAtmTechAlgorithm",
    component: () => import("@/views/document/atmtechalgorithm/view.vue"),
    meta: {
      pageTitle: "AtmTechAlgorithm",
      navActiveLink: "atmtechalgorithm",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AtmTechAlgorithm",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nmdsettlementaccountconfig",
    name: "nmdsettlementaccountconfig",
    component: () =>
      import("@/views/info/nmdsettlementaccountconfig/index.vue"),
    meta: {
      pageTitle: "NmdSettlementAccountConfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NmdSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nmdsettlementaccountconfig/edit/id=:id",
    name: "EditNmdSettlementAccountConfig",
    component: () => import("@/views/info/nmdsettlementaccountconfig/edit.vue"),
    meta: {
      pageTitle: "NmdSettlementAccountConfig",
      navActiveLink: "nmdsettlementaccountconfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NmdSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nmdsettlementaccountconfig/view/id=:id",
    name: "ViewNmdSettlementAccountConfig",
    component: () => import("@/views/info/nmdsettlementaccountconfig/view.vue"),
    meta: {
      pageTitle: "NmdSettlementAccountConfig",
      navActiveLink: "nmdsettlementaccountconfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NmdSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/allatmsettlementaccountconfig",
    name: "allatmsettlementaccountconfig",
    component: () =>
      import("@/views/document/allatmsettlementaccountconfig/index.vue"),
    meta: {
      pageTitle: "AllAtmSettlementAccountConfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AllAtmSettlementAccountConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/collectortask",
    name: "collectortask",
    component: () => import("@/views/document/collectortask/index.vue"),
    meta: {
      pageTitle: "CollectorTask",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CollectorTask",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/collectortask/view/id=:id",
    name: "ViewCollectorTask",
    component: () => import("@/views/document/collectortask/view.vue"),
    meta: {
      pageTitle: "CollectorTask",
      navActiveLink: "collectortask",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "CollectorTask",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/documenthistory",
    name: "documenthistory",
    component: () => import("@/views/document/documenthistory/index.vue"),
    meta: {
      pageTitle: "DocumentHistory",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "DocumentHistory",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/documentheld/allatmcashlist",
    name: "allatmcashlist",
    component: () =>
      import("@/views/document/documentheld/allatmcashlist/index.vue"),
    meta: {
      pageTitle: "AllCashList",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AllCashList",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/documentheld/alldocumentlist",
    name: "alldocumentlist",
    component: () =>
      import("@/views/document/documentheld/alldocumentlist/index.vue"),
    meta: {
      pageTitle: "AllDocumentList",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "AllDocumentList",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/smssendconfig",
    name: "smssendconfig",
    component: () => import("@/views/document/smssendconfig/index.vue"),
    meta: {
      pageTitle: "SmsSendConfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SmsSendConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/smssendconfig/edit/id=:id",
    name: "EditSmsSendConfig",
    component: () => import("@/views/document/smssendconfig/edit.vue"),
    meta: {
      pageTitle: "SmsSendConfig",
      navActiveLink: "smssendconfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SmsSendConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/smssendconfig/view/id=:id",
    name: "ViewSmsSendConfig",
    component: () => import("@/views/document/smssendconfig/view.vue"),
    meta: {
      pageTitle: "SmsSendConfig",
      navActiveLink: "smssendconfig",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "SmsSendConfig",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/recountactnewdocs",
    name: "recountactnewdocs",
    component: () => import("@/views/document/recountactnewdocs/index.vue"),
    meta: {
      pageTitle: "RecountactNewDocs",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "RecountactNewDocs",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/optiload",
    name: "optiload",
    component: () => import("@/views/document/optiload/index.vue"),
    meta: {
      pageTitle: "Optiload",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "Optiload",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscbanknotelimit",
    name: "bscbanknotelimit",
    component: () => import("@/views/document/bscbanknotelimit/index.vue"),
    meta: {
      pageTitle: "BscBanknoteLimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscBanknoteLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscbanknotelimit/edit/id=:id",
    name: "EditBscBanknoteLimit",
    component: () => import("@/views/document/bscbanknotelimit/edit.vue"),
    meta: {
      pageTitle: "BscBanknoteLimit",
      navActiveLink: "bscbanknotelimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscBanknoteLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/bscbanknotelimit/view/id=:id",
    name: "ViewBscBanknoteLimit",
    component: () => import("@/views/document/bscbanknotelimit/view.vue"),
    meta: {
      pageTitle: "BscBanknoteLimit",
      navActiveLink: "bscbanknotelimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "BscBanknoteLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nmdbanknotelimit",
    name: "nmdbanknotelimit",
    component: () => import("@/views/document/nmdbanknotelimit/index.vue"),
    meta: {
      pageTitle: "NmdBanknoteLimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NmdBanknoteLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nmdbanknotelimit/edit/id=:id",
    name: "EditNmdBanknoteLimit",
    component: () => import("@/views/document/nmdbanknotelimit/edit.vue"),
    meta: {
      pageTitle: "NmdBanknoteLimit",
      navActiveLink: "nmdbanknotelimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NmdBanknoteLimit",
          active: true,
        },
      ],
    },
  },
  {
    path: "/doc/nmdbanknotelimit/view/id=:id",
    name: "ViewNmdBanknoteLimit",
    component: () => import("@/views/document/nmdbanknotelimit/view.vue"),
    meta: {
      pageTitle: "NmdBanknoteLimit",
      navActiveLink: "nmdbanknotelimit",
      breadcrumb: [
        {
          text: "Document",
        },
        {
          text: "NmdBanknoteLimit",
          active: true,
        },
      ],
    },
  },
]
